import { shipmentsContracts } from "./shipments.contract";

export const supplyChainContracts = {
  shipments: shipmentsContracts,
} as const;

export * from "./shipments.contract";
